import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {NotificationCellBase, NotificationCellBasePublicProps} from './notificationCellBase';

/*
 * Props.
 */

interface RuleNotificationCellProps extends NotificationCellBasePublicProps {}

/*
 * Style.
 */

const StyledNameSpan = styled.span`
  font-weight: ${fontWeights.bold};
`;

/*
 * Component.
 */

export const RuleNotificationCell: FC<RuleNotificationCellProps> = (props) => (
  <NotificationCellBase {...props} icon={renderIcon()} title={renderTitle(props)}>
    {props.notification.summary}
  </NotificationCellBase>
);

function renderIcon() {
  return (
    <UserThemeConsumer>{(theme) => <Icon name="gearSmall" color={theme.greys.shade90} />}</UserThemeConsumer>
  );
}

function renderTitle(props: RuleNotificationCellProps) {
  const {fromRuleName} = props.notification;
  if (!fromRuleName) {
    return <Trans id="nc-rule-generic">A rule notified you</Trans>;
  }

  return (
    <Trans id="nc-rule-name">
      <StyledNameSpan>{fromRuleName}</StyledNameSpan> notified you
    </Trans>
  );
}
